const whiteListEmails = [
  'vinicius@ten.com.br',
  'paulo.moreno@ten.com.br',
  'pedro.henrique@ten.com.br',
];

export const verifyUserWhiteList = (userEmail: string) => {
  return whiteListEmails.includes(userEmail);
};
